export const ANALYTICS_HEADER_HEIGHT = 54;
export const ANALYTICS_HEADER_SHELL_HEIGHT = 46;
export const ANALYTICS_SIDEBAR_CONTENT_INSET = 20;

const getMarketingControlBorder = (theme) => (
  theme.palette.mode === 'light'
    ? 'rgba(16, 34, 53, 0.08)'
    : 'rgba(124, 158, 224, 0.24)'
);

export const getHeaderBackdropSx = (theme) => ({
  height: `calc(${ANALYTICS_HEADER_HEIGHT}px + env(safe-area-inset-top))`,
  flex: '0 0 auto',
  backgroundColor: theme.chrome?.headerBackdrop || theme.workspace?.toolbar || theme.chrome?.pageBackground,
});

export const getHeaderFrameSx = (theme) => ({
  top: 0,
  zIndex: 1200,
  height: `calc(${ANALYTICS_HEADER_HEIGHT}px + env(safe-area-inset-top))`,
  backgroundColor: 'transparent',
  boxShadow: 'none',
  paddingTop: 'env(safe-area-inset-top)',
  fontFamily: theme.chrome?.fontFamily,
});

export const getHeaderShellSx = (theme) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  width: { xs: 'calc(100% - 16px)', md: 'min(1280px, calc(100% - 32px))' },
  px: { xs: '12px', sm: '16px' },
  height: ANALYTICS_HEADER_SHELL_HEIGHT,
  minHeight: ANALYTICS_HEADER_SHELL_HEIGHT,
  my: `${(ANALYTICS_HEADER_HEIGHT - ANALYTICS_HEADER_SHELL_HEIGHT) / 2}px`,
  mx: 'auto',
  border: `1px solid ${theme.chrome?.headerBorder || theme.palette.divider}`,
  borderRadius: `${ANALYTICS_HEADER_SHELL_HEIGHT / 2}px`,
  backgroundColor: theme.chrome?.headerSurface || theme.palette.background.paper,
  boxShadow: theme.chrome?.headerShadow,
  backdropFilter: 'blur(18px)',
  WebkitBackdropFilter: 'blur(18px)',
  transition: 'background-color 0.2s ease, border-color 0.2s ease, box-shadow 0.2s ease',
});

export const getHeaderSearchContainerSx = (theme, isFocused) => ({
  position: 'relative',
  flex: '0 0 184px',
  width: 184,
  minWidth: 184,
  height: 34,
  border: `1px solid ${isFocused ? theme.palette.primary.main : getMarketingControlBorder(theme)}`,
  borderRadius: '999px',
  backgroundColor: theme.palette.mode === 'light'
    ? (isFocused ? 'rgba(255, 255, 255, 0.88)' : 'rgba(255, 255, 255, 0.72)')
    : (isFocused ? 'rgba(255, 255, 255, 0.14)' : 'rgba(255, 255, 255, 0.10)'),
  boxShadow: isFocused ? `0 0 0 3px ${theme.chrome?.focusRing || theme.palette.action.focus}` : 'none',
  transition: 'border-color 0.2s ease, box-shadow 0.2s ease, background-color 0.2s ease',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'light'
      ? 'rgba(255, 255, 255, 0.88)'
      : 'rgba(255, 255, 255, 0.14)',
  },
});

export const getHeaderSearchInputSx = (theme) => ({
  height: 32,
  px: 1.25,
  border: 'none',
  borderRadius: '999px',
  backgroundColor: 'transparent',
  fontFamily: theme.chrome?.fontFamily,
  '& .MuiInputBase-input': {
    height: '18px',
    padding: '4px 0',
    fontSize: '12px',
    textAlign: 'left',
  },
  '& .MuiInputBase-input::placeholder': {
    color: theme.palette.mode === 'light' ? theme.palette.text.primary : theme.palette.text.secondary,
    opacity: theme.palette.mode === 'light' ? 0.72 : 0.9,
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none',
  },
});

export const getHeaderSignInSx = (theme, mobile = false) => ({
  width: mobile ? '100%' : 'auto',
  minWidth: mobile ? 0 : 'auto',
  minHeight: mobile ? 50 : 30,
  px: mobile ? 3 : 1.5,
  border: `1px solid ${getMarketingControlBorder(theme)}`,
  borderRadius: '999px',
  backgroundColor: theme.chrome?.headerSurface || theme.palette.background.paper,
  boxShadow: 'none',
  color: theme.palette.text.primary,
  fontFamily: theme.chrome?.fontFamily,
  fontSize: mobile ? '14px' : '13px',
  fontWeight: 700,
  textTransform: 'none',
  transition: 'transform 0.18s ease, box-shadow 0.18s ease, background-color 0.18s ease',
  '&:hover': {
    backgroundColor: theme.chrome?.menuSurface || theme.palette.background.paper,
    boxShadow: theme.chrome?.headerShadow,
    transform: 'translateY(-1px)',
  },
});

export const getHeaderIconActionSx = (theme) => ({
  width: 44,
  height: 44,
  minWidth: 44,
  minHeight: 44,
  padding: 0,
  border: 0,
  borderRadius: '999px',
  backgroundColor: 'transparent',
  color: theme.palette.primary.main,
  transition: 'transform 0.18s ease, background-color 0.18s ease',
  '&:hover': {
    backgroundColor: 'transparent',
    transform: 'translateY(-1px)',
  },
});

export const getMobileHeaderSearchSx = (theme) => ({
  '& .MuiOutlinedInput-root': {
    height: 42,
    borderRadius: '999px',
    backgroundColor: theme.chrome?.menuSurface || theme.palette.background.paper,
    '& fieldset': {
      borderColor: theme.chrome?.headerBorder || theme.palette.divider,
    },
    '&:hover fieldset': {
      borderColor: theme.palette.primary.main,
    },
    '&.Mui-focused fieldset': {
      borderColor: theme.palette.primary.main,
      boxShadow: `0 0 0 3px ${theme.chrome?.focusRing || theme.palette.action.focus}`,
    },
  },
  '& .MuiInputBase-input': {
    color: theme.palette.text.primary,
    fontFamily: theme.chrome?.fontFamily,
    fontSize: '14px',
    '&::placeholder': {
      color: theme.palette.text.secondary,
      opacity: 0.8,
    },
  },
});
